import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  #carbonads {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu,\n    Cantarell, \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  }\n\n  #carbonads {\n    display: flex;\n    max-width: 330px;\n    background-color: adsBg;\n    box-shadow: 0 1px 4px 1px hsla(0, 0%, 0%, .1);\n  }\n\n  #carbonads a {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  #carbonads a:hover {\n    color: inherit;\n  }\n\n  #carbonads span {\n    position: relative;\n    display: block;\n    overflow: hidden;\n  }\n\n  #carbonads .carbon-wrap {\n    display: flex;\n  }\n\n  .carbon-img {\n    display: block;\n    margin: 0;\n    line-height: 1;\n  }\n\n  .carbon-img img {\n    display: block;\n  }\n\n  .carbon-text {\n    font-size: 13px;\n    padding: 10px;\n    line-height: 1.5;\n    text-align: left;\n  }\n\n  .carbon-poweredby {\n    display: block;\n    padding: 8px 10px;\n    background: repeating-linear-gradient(-45deg, transparent, transparent 5px, hsla(0, 0%, 0%, .025) 5px, hsla(0, 0%, 0%, .025) 10px) hsla(203, 11%, 95%, .4);\n    text-align: center;\n    text-transform: uppercase;\n    letter-spacing: .5px;\n    font-weight: 600;\n    font-size: 9px;\n    line-height: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import staticQueryData from "../../../../public/static/d/1678272686.json";
import React, { useEffect } from 'react';
import { StaticQuery } from 'gatsby';
import { createGlobalStyle } from '@xstyled/styled-components';
var GlobalStyle = createGlobalStyle(_templateObject());
var QUERY = "1678272686";

function InnerCarbonAd(_ref) {
  var url = _ref.url;
  var ref = React.useRef();
  useEffect(function () {
    var wrapper = ref.current;
    var script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.id = '_carbonads_js';
    wrapper.appendChild(script);
    return function () {
      wrapper.removeChild(script);
    };
  }, [url]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyle, {
    colorMode: "dark"
  }), /*#__PURE__*/React.createElement("div", {
    ref: ref
  }));
}

export function CarbonAd() {
  return /*#__PURE__*/React.createElement(StaticQuery, {
    query: QUERY,
    render: function render(data) {
      return data.site.siteMetadata.carbonAdUrl ? /*#__PURE__*/React.createElement(InnerCarbonAd, {
        url: data.site.siteMetadata.carbonAdUrl
      }) : /*#__PURE__*/React.createElement(InnerCarbonAd, {
        url: "//cdn.carbonads.com/carbon.js?serve=CE7I5K3U&placement=loadable-componentscom"
      });
    },
    data: staticQueryData
  });
}